import { memo, useEffect, useState } from "react"
import { Link, useParams } from "react-router-dom";
import useScrolledFetch from "hooks/useScrolledFetch";
import moment from "jalali-moment";
import UseFetch from "hooks/useFetch";
import Send from "./send";
import { useInView } from "react-intersection-observer";
import Breadcrumb from "components/shared/breadcrumb";
import ticketStatuses from "constants/ticket-statuses";
import Feedback from "./feedback";
import { CSSTransition } from "react-transition-group";
import { toast } from "react-toastify";
import MasterAPI from "service/master";
import Loading from "components/shared/loading";

const getTicketTitle = reply => {
    if (reply.user_kind === 3)
        return <>کارشناس پشتیبان - {reply.name}</>

    return "شما";
}

const View = () => {
    const messagesPerPage = 5;

    const { id } = useParams();
    const { inView, ref: moreElRef } = useInView();
    const { isLoading, data, error, mutate: ticketMutate } = UseFetch(`/api/ticket/get?id=${id}`);
    const [limit, setLimit] = useState(messagesPerPage);
    const [closeLoading, setCloseLoading] = useState(false);

    const {
        isLoading: messagesLoading,
        data: messagesData,
        error: messagesError,
        loadMoreLoading,
        mutate
    } = useScrolledFetch({ url: `/api/ticket/list_replies?id=${id}&limit=${limit}` });

    useEffect(() => {
        if (!loadMoreLoading && inView)
            setLimit(prev => prev + messagesPerPage);

        // eslint-disable-next-line
    }, [inView])

    const closeHandler = async () => {
        if (closeLoading)
            return;

        setCloseLoading(true);

        try {
            const res = await MasterAPI({
                url: "/api/ticket/close",
                method: "PUT",
                data: { id },
                payloadType: 3,
                callback: () => setCloseLoading(false)
            });

            toast.success(res.message);
            ticketMutate();
        } catch (e) {
            toast.error(e.message);
        }
    }

    return (
        <div>
            <div className="p-3">
                <div className="flex item-start md:items-center justify-start md:justify-between flex-col md:flex-row mb-10">
                    <div className="mb-6 md:mb-0">
                        <h1 className="title-c1 tp-21">جزئیات تیکت</h1>

                        <Breadcrumb data={[
                            { title: "تعاملات کاربران" },
                            { title: "تیکت", link: "/panel/ticket" },
                            { title: "جزئیات تیکت" }
                        ]} />
                    </div>

                    <div className="flex">
                        <Link to={"/panel/ticket"} className="w-10 h-10 tp-22 text-[#424e79] dark:text-white ml-3 rounded-md fit-center">
                            <i className="fa-regular fa-arrow-right"></i>
                        </Link>

                        <button className="w-10 h-10 tp-22 text-[#424e79] dark:text-white rounded-md fit-center" onClick={() => { ticketMutate(); mutate() }} title="بروزرسانی">
                            <i className="fa-regular fa-arrows-retweet"></i>
                        </button>

                        {
                            [0, 1].indexOf(data.data?.status_id) !== -1 && (
                                <button
                                    className={`bg-primary-100 hover:bg-primary-200 px-4 transition-colors text-white rounded-md fit-center text-sm h-10 mr-3 relative overflow-hidden${closeLoading ? " cursor-progress" : ""}`}
                                    onClick={closeHandler}
                                >
                                    <i className="fa-duotone fa-check-double ml-2"></i>
                                    بستن تیکت

                                    <CSSTransition in={closeLoading} timeout={200} unmountOnExit={true}>
                                        <span className="pos-cover bg-primary-200 fit-center anim-c4">
                                            <i className="fa-solid fa-spinner spin"></i>
                                        </span>
                                    </CSSTransition>
                                </button>
                            )
                        }
                    </div>
                </div>

                <div className="wrap-box tp-22 tickets">
                    {
                        !isLoading ? (
                            !error ? (
                                <>
                                    <div className="grid grid-cols-12 gap-4 text-sm pb-5 border-b border-gray-200 dark:border-slate-700 mb-4 text-gray-800 dark:text-slate-100">
                                        <div className="col-span-1">
                                            <b className="font-medium">عنوان</b>
                                        </div>

                                        <div className="col-span-11">
                                            {data.data.subject}
                                        </div>

                                        <div className="col-span-1">
                                            <b className="font-medium">وضعیت</b>
                                        </div>

                                        <div className="col-span-11">
                                            {ticketStatuses[data.data.status_id].title}
                                            <i className={`${ticketStatuses[data.data.status_id].icon} mr-2`} />
                                        </div>

                                        <div className="col-span-1">
                                            <b className="font-medium">زمان ایجاد</b>
                                        </div>

                                        <div className="col-span-11">
                                            {moment.unix(data.data.created_at).format("hh:mm - jYYYY/jMM/jD")}
                                        </div>

                                        {
                                            (data.data.status_id === 2 || data.data.status_id === 3) && (
                                                <>
                                                    <div className="col-span-1">
                                                        <b className="font-medium">بازخورد تیکت</b>
                                                    </div>

                                                    <div className="col-span-11">
                                                        <Feedback isUseful={data.data.is_useful} />
                                                    </div>
                                                </>
                                            )
                                        }
                                    </div>

                                    <div className="grid grid-cols-12 gap-4 text-sm pb-5 border-b border-gray-200 dark:border-slate-700 mb-4 text-gray-800 dark:text-slate-100">
                                        <div className="col-span-1">
                                            <b className="font-medium">توضیحات</b>
                                        </div>

                                        <div className="col-span-11">
                                            {data.data.description}
                                        </div>
                                    </div>

                                    {
                                        data.data.status_id !== 2 && data.data.status_id !== 3 && (
                                            <Send mutate={mutate} />
                                        )
                                    }

                                    {
                                        !messagesLoading ? (
                                            !messagesError ? (
                                                <>
                                                    {
                                                        messagesData.data.map(reply => (
                                                            <div className="ticket" key={`reply-${reply.id}`}>
                                                                <div className="title hasBB">
                                                                    <b>{getTicketTitle(reply)}</b>

                                                                    <div className="time">
                                                                        <span>{moment.unix(reply.created_at).format("jYYYY/jMM/jDD")}</span>
                                                                        <span className="line"></span>
                                                                        <span>{moment.unix(reply.created_at).format("hh:mm")}</span>
                                                                    </div>
                                                                </div>

                                                                <p className="pre-line">{reply.message}</p>
                                                            </div>
                                                        ))
                                                    }

                                                    {messagesData.count > limit && <div ref={moreElRef} />}
                                                </>
                                            ) : <p className="text-sm text-red-400">خطا در دریافت اطلاعات ...</p>
                                        ) : <div className="flex justify-center"><Loading className="loading-c5" /></div>
                                    }
                                </>
                            ) : <p className="text-sm text-red-400">خطا در دریافت اطلاعات ...</p>
                        ) : <div className="flex justify-center"><Loading className="loading-c5" /></div>
                    }
                </div>
            </div>
        </div>
    )
}

export default memo(View);